import { useCallback } from 'react'
import { Dispatch } from 'redux'
import * as actions from 'client/actions/entityActions'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'

export const useUpdateEntityStyle = (
  dispatch: Dispatch<any>,
  entity: OldEntityInterface,
) => {
  return useCallback(
    (style: OldEntityInterface['styles'], sizing = null) =>
      (value: string) =>
        dispatch(
          actions.update({
            ...entity,
            styles: {
              ...entity.styles,
              [style]: sizing ? `${value}${sizing}` : value,
            },
          }),
        ),
    [entity],
  )
}
